const KEY = 'whitcomb_finance_v1';

export const saveData = (data) => {
  try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
};

export const loadData = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) { return null; }
};

export const formatCurrency = (n, decimals = 0) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(n);

export const formatDate = (d) => new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

export const calcFutureValue = (presentValue, annualRate, years) => {
  return presentValue * Math.pow(1 + annualRate / 100, years);
};
